import { api } from "@/lib/api";

/**
 * Signed Cloudinary upload flow.
 * @param {File} file
 * @param {"image"|"video"} resourceType
 * @param {string} folder – aurora/products, aurora/hero, aurora/banners, etc.
 * @returns {Promise<string>} secure_url
 */
export async function uploadToCloudinary(file, resourceType = "image", folder = "aurora/products") {
  const sig = await api.get("/admin/upload/signature", { params: { folder } });
  const { signature, timestamp, cloud_name, api_key, folder: uploadFolder } = sig.data;

  const form = new FormData();
  form.append("file", file);
  form.append("api_key", api_key);
  form.append("timestamp", timestamp);
  form.append("signature", signature);
  form.append("folder", uploadFolder);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${cloud_name}/${resourceType}/upload`,
    { method: "POST", body: form }
  );
  const data = await res.json();
  if (!data.secure_url) {
    throw new Error(data.error?.message || "Upload gagal");
  }
  return data.secure_url;
}
